/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { TaxRateRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { Observable } from 'rxjs';
import { TaxRate } from './tax-rate.model';

export interface TaxRateFinderDialogConfig extends FinderDialogConfig {
  tmpCredentials?: boolean;
}

@Injectable()
export class TaxRateFinderBusinessService {
  constructor(private accountingTaxRatesRest: TaxRateRestService) {
  }

  findAll(tmpCredentials?: boolean): Observable<TaxRate[]> {
    return this.accountingTaxRatesRest.findAll();
  }
}
